import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';

@Component({
  selector: 'app-modal',
  template: `
    <div class="modal-backdrop fade show"></div>
    <div [class]="'modal fade show d-block' + (windowClass ? ' ' + windowClass : '')">
      <div [class]="'modal-dialog' + (size ? ' modal-' + size : '')">
        <div class="modal-content">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .modal, .modal-backdrop {
      z-index: 1040;
    }
  `]
})
export class ModalComponent implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('attr.tabindex') tabIndex = -1;
  @Input() backdrop = true;
  @Input() keyboard = true;
  @Input() size: string;
  @Input() windowClass: string;
  @Output() dismiss = new EventEmitter();

  private focusedEl: HTMLElement;
  private isChild: boolean;

  constructor(
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.focusedEl = <HTMLElement>document.activeElement;
    this.isChild = document.body.classList.contains('modal-open');
    if (!this.isChild) {
      this.renderer.addClass(document.body, 'modal-open');
    }
  }

  ngAfterViewInit() {
    this.elRef.nativeElement.focus();
  }

  ngOnDestroy() {
    const body = document.body;
    const focusedEl = this.focusedEl;
    const elToFocus = focusedEl && body.contains(focusedEl) ? focusedEl : body;

    elToFocus.focus();
    this.focusedEl = null;
    if (!this.isChild) {
      this.renderer.removeClass(body, 'modal-open');
    }
  }

  @HostListener('click', ['$event']) backdropClick(e: MouseEvent) {
    if (this.backdrop && this.elRef.nativeElement.lastElementChild === e.target) {
      this.dismiss.emit();
    }
  }

  @HostListener('keyup.esc', ['$event']) escKeyUp(e: KeyboardEvent) {
    if (this.keyboard && !e.defaultPrevented) {
      this.dismiss.emit();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal/modal.component.ts